import React, { useEffect, useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import useMuiCompontent from '../../Hooks/useMuiCompontent';
import { PATIENT_BILLING, UPDATE_PATIENT_BILLING, BILLING_PAYMENT } from '../Repository/AppointmentsRepo';
import { toast } from 'react-toastify';
import Loading from '../../Component/Loading';
import moment from 'moment-timezone';
import { SelectBox } from '../../Component/Inputs';
import { useLocation } from 'react-router-dom';
import useReduxData from '../../Hooks/useReduxData';
import { paymentTypes, cardTypes, RoleTitle } from '../../Context/constants';
import { useNavigate } from 'react-router-dom';

const PatientBill = () => {
    const componentRef = useRef();
    const { CustomButton } = useMuiCompontent()
    const [patientBilling, setPatientBilling] = useState({})
    const [loader, setLoader] = useState(false)
    const [gstType, setGstType] = useState("inclusive")
    const [paymentType, setPaymentType] = useState("Cash");
    const [cardType, setCardType] = useState("Visa");
    const [cardNumber, setCardNumber] = useState("");
    const [chequeNumber, setChequeNumber] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const { reduxData: userdata } = useReduxData("userDataRDX")
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const patientId = params.get("patientId") ?? undefined;
    const appointmentId = params.get("appointmentId") ?? undefined;
    const providerId = params.get("providerId") ?? undefined;
    const paymentDate = moment(patientBilling?.createdOn).format("YYYY-MM-DD");
    const [shouldBreakPage, setShouldBreakPage] = useState(false);
    const navigate = useNavigate();
    const pageLength = useRef();
    const handlePrint = () => {
        const element = componentRef.current;
        html2pdf()
            .set({
                margin: 3,
                filename: `patientBill.pdf`,
                image: { type: 'jpeg', quality: 1 },
                html2canvas: { scale: 2, useCORS: true, logging: true, windowWidth: 794, windowHeight: 1123 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: [], avoid: ['table', '.note', '.footer-row'] }
            })
            .from(element)
            .save();
    };


    const getPatientBilling = async (gstTypes = undefined) => {
        let payload = {
            gstType: gstTypes ?? gstType,
            patientId: patientId,
            appointmentId: appointmentId,
            providerId: providerId,
            createdById: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.SERVICE_PROVIDER)
                ? userdata?.providerId
                : userdata?.userId,
        }
        setLoader(true)
        try {
            let response = await PATIENT_BILLING(payload)
            if (!response?.data) {
                toast.warning("No bill found for this patient");
                setPatientBilling({});
                setLoader(false);
                return;
            }

            setPatientBilling(response.data);
            setLoader(false)
        } catch (error) {
            toast.error(error.message);
            setPatientBilling({})
            setLoader(false)
        }
    }
    const updatePatientBill = async (gstTypes) => {

        let payload = {
            gstType: gstTypes,
            patientId: patientId,
            appointmentId: appointmentId,
            providerId: providerId
        }
        setLoader(true)
        try {
            await UPDATE_PATIENT_BILLING(payload)

            getPatientBilling(gstTypes)
            setLoader(false)
        } catch (error) {
            toast.error(error.message);

            setLoader(false)
        }
    }

    const addPaymentDetails = async () => {

        if (paymentType === "Card" && cardNumber.length !== 19) {
            toast.error("Please enter a valid card number");
            setLoader(false);
            return;
        }
        if (paymentType === "Cheque" && !chequeNumber) {
            toast.error("Please enter a valid cheque number");
            setLoader(false);
            return;
        }
        if (paymentType === "Online Payment" && !transactionId) {
            toast.error("Please enter a valid transaction ID");
            setLoader(false);
            return;
        }

        let payload = {
            billId: patientBilling.billId,
            patientId: patientId,
            appointmentId: appointmentId,
            providerId: providerId,
            paymentType: paymentType,
            ...(paymentType === 'Card' && { cardType: cardType }),
            ...(paymentType === 'Card' && { cardNumber: cardNumber.replace(/\D/g, "").slice(-4) }),
            ...(paymentType === 'Cheque' && { chequeNumber: chequeNumber }),
            ...(paymentType === 'Online Payment' && { transactionId: transactionId }),
            paymentDate: paymentDate
        }

        setLoader(true)
        try {

            await BILLING_PAYMENT(payload);


            setLoader(false)

        } catch (error) {
            console.error("Error in addPaymentDetails:", error);
            toast.error(error.message);

            setLoader(false)
        }
    }

    const handleSavePayment = async () => {
        await addPaymentDetails();
        navigate("/appointment/today-agenda");
    };

    const fullClinicAddress = [
        patientBilling?.clinicAddress,
        patientBilling?.clinicCity,
        patientBilling?.cinicState,
        patientBilling?.clinicZipCode,
    ].filter(Boolean).join(", ");

    const notesItems = [
        "This bill is generated electronically and does not require a signature.",
        "Services are inclusive of consumables unless mentioned.",
        "Please retain this bill for insurance or tax purposes.",
        "No personal health information is shared without consent in compliance with HIPAA."
    ]

    useEffect(() => {
        if (pageLength.current) {
            const height = pageLength.current.offsetHeight;
            console.log(height, "height")
            if (height > 700) setShouldBreakPage(true);
        }

    }, [patientBilling]);


    useEffect(() => {
        getPatientBilling()
    }, [])

    useEffect(() => {
        if (patientBilling?.billId) {
            addPaymentDetails();
        }
    }, [patientBilling?.billId]);
    return (
        <>
            {loader && <Loading />}
            <div className="common-component-box">
                <header className="body_header">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                        <h2 className="pe-5 page_name mb-3 mb-md-0">Patient Bill</h2>
                        <div className='ps-5 d-flex flex-wrap align-items-center gap-2'>
                            <ul className='d-flex flex-wrap p-0 m-0 gap-0' style={{ listStyle: "none" }}>
                                <li className="me-2" style={{ width: 190 }}>
                                    <SelectBox
                                        placeholder="Select"
                                        value={paymentType}
                                        name="archive"
                                        keys="value"
                                        label="label"
                                        menuValeu="value"
                                        handleChange={(e) => { setPaymentType(e.target.value); }}
                                        option={paymentTypes}
                                    />
                                </li>
                                {paymentType === 'Card' && (
                                    <>
                                        <li className="me-2" style={{ width: 190 }}>
                                            <SelectBox
                                                placeholder="Select"
                                                value={cardType}
                                                name="archive"
                                                keys="value"
                                                label="label"
                                                menuValeu="value"
                                                handleChange={(e) => { setCardType(e.target.value); }}
                                                option={cardTypes}
                                            />

                                        </li>
                                        <li className="me-2" style={{ width: 190 }}>
                                            <input
                                                type='text'
                                                value={cardNumber}
                                                maxLength={19}
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/\D/g, '');
                                                    value = value.replace(/(.{4})/g, '$1 ').trim();
                                                    if (value.length <= 19) {
                                                        setCardNumber(value)
                                                    }
                                                }
                                                }
                                                placeholder='Card Number'
                                                className='form-control'
                                                style={{ height: "34px", fontSize: "14px" }}
                                            />

                                        </li>
                                    </>
                                )}
                                {paymentType === 'Cheque' && (
                                    <li className="me-2" style={{ width: 190 }}>
                                        <input
                                            type='text'
                                            value={chequeNumber}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, '');
                                                setChequeNumber(value)
                                            }}
                                            placeholder='Cheque Number'
                                            className='form-control'
                                            style={{ height: "34px", fontSize: "14px" }}
                                        />

                                    </li>
                                )}
                                {paymentType === 'Online Payment' && (
                                    <li className="me-2" style={{ width: 190 }}>
                                        <input
                                            type='text'
                                            value={transactionId}
                                            onChange={(e) => { setTransactionId(e.target.value) }}
                                            placeholder='Transaction ID'
                                            className='form-control'
                                            style={{ height: "34px", fontSize: "14px" }}
                                        />

                                    </li>
                                )}
                                <li style={{ width: 190 }}>
                                    <SelectBox
                                        placeholder="Select"
                                        value={gstType}
                                        name="archive"
                                        keys="value"
                                        label="label"
                                        menuValeu="value"
                                        handleChange={(e) => { setGstType(e.target.value); updatePatientBill(e.target.value) }}
                                        option={[
                                            { value: "inclusive", label: "Inclusive" },
                                            { value: "exclusive", label: "Exclusive" },
                                        ]}
                                    />
                                </li>
                            </ul>

                            <div className="d-flex flex-wrap gap-2 mt-2 mt-md-0">
                                <CustomButton
                                    onClick={handleSavePayment}
                                    variant="contained"
                                    disabled={loader}
                                >
                                    Save Payment
                                </CustomButton>

                                <CustomButton
                                    onClick={handlePrint}
                                    variant="contained" >Download PDF</CustomButton>
                            </div>
                        </div>
                    </div>
                </header>

                <div ref={componentRef} className="common-white-bg-box mx-0 shadow patient_bill">
                    <div ref={pageLength}>
                        <div className="p-4 d-flex flex-column h-100" >
                            <div className='position-relative clinic-info d-flex'>
                                <div className="col-3"></div>
                                <div className='text-center col-5'>
                                    <h3 className='mb-0'>{patientBilling?.clinicName}</h3>
                                    <p className='mb-0'>{fullClinicAddress} </p>
                                    <p className='mb-0'>
                                        {patientBilling?.clinicGstNumber ? `GSTIN : ${patientBilling.clinicGstNumber}` : ""}
                                        {patientBilling?.providerMobile ? ` Phone : ${patientBilling.providerMobile}` : ""}
                                    </p>

                                    <p className='mb-0'>
                                        {patientBilling?.providerEmail ? `Email : ${patientBilling.providerEmail}` : ""}
                                    </p>

                                </div>

                                <div className="barcode col-3 text-end" >
                                    <div dangerouslySetInnerHTML={{ __html: patientBilling?.barcode }} />
                                </div>
                            </div>
                            <hr />
                            <div>
                                <h4 className='text-center'>Medical Bill</h4>

                                <div className="d-flex justify-content-between mt-4 info">
                                    <div>
                                        <h5>Bill Details</h5>
                                        <p>Bill No : {patientBilling?.invoiceNumber ?? "N/A"}</p>
                                        <p>Date : {moment(patientBilling?.createdOn).format("DD/MM/YYYY")}</p>
                                        <p>Due Date : {moment(patientBilling?.dueDate).format("DD/MM/YYYY")}</p>
                                    </div>
                                    <div>
                                        <h5>Patient Information</h5>
                                        <p>Appointment No : {patientBilling?.appointmentNumber ?? "N/A"} </p>
                                        <p>Name : {patientBilling?.patientFirstName ?? ""} {patientBilling?.patientLastName ?? ""} </p>
                                        <p>Patient ID : {patientBilling?.patientId} </p>
                                    </div>
                                </div>

                                <hr />

                                {/* <div className="d-flex justify-content-between tax_invoice">
                                <div>
                                    <strong>INVOICE NUMBER</strong>
                                    <div>{patientBilling?.invoiceNumber ?? "N/A"}</div>
                                </div>
                                <div>
                                    <strong>DATE</strong>
                                    <div> {moment(patientBilling?.createdOn).format("DD/MM/YYYY")}</div>
                                </div>
                                <div>
                                    <strong>Amount</strong>
                                    <div><strong>{patientBilling?.currencyImage ?? ""}{patientBilling?.amountDue?.toFixed(2)}</strong></div>
                                </div>
                            </div> */}
                            </div>
                            <div className='flex-fill pb-3'>
                                {/* <table className="table mt-4">
                                <thead>
                                    <tr>
                                        <th align="left">ITEM</th>
                                        <th align="left">HSN Code</th>
                                        <th align="left" >AMOUNT</th>
                                        <th align="left">GST Rate</th>
                                        <th align="left">GST AMOUNT</th>
                                        <th align="left">CGST</th>
                                        <th align="left">SGST</th>
                                        <th align="left">IGST</th>
                                        <th align="right" className='text-end'>TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        patientBilling?.billingItems?.map((cur, index) => {
                                            return <tr>
                                                <td>{cur?.serviceName ?? "-"}</td>
                                                <td>{cur?.hsnCode ?? "-"}</td>
                                                <td>{cur?.currencyImage ?? ""}{cur?.taxableValue ?? "-"}</td>
                                                <td>{cur?.gstRate ?? "-"}%</td>
                                                <td>{cur?.currencyImage ?? ""}{cur?.gstAmount ?? "-"}</td>
                                                <td>{cur?.cgst ?? "-"}</td>
                                                <td>{cur?.sgst ?? "-"}</td>
                                                <td>{cur?.igst ?? "-"}</td>
                                                <td align="right">{cur?.currencyImage ?? ""}{cur?.amount ?? "-"}</td>
                                            </tr>
                                        })
                                    }

                                </tbody>
                            </table> */}

                                <table className="table mt-4 a4-print-table" style={{ textIndent: '10px' }}>
                                    <thead>
                                        <tr>
                                            <th scope="col" className="col-5 description-service" align="left">Description of service</th>
                                            <th scope="col" align="left">HSN Code</th>
                                            <th scope="col" align="left" >Qty</th>
                                            <th scope="col" align="left">Price ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">GST (%)</th>
                                            <th scope="col" align="right" className='text-end'> <div style={{ paddingRight: '10px' }}>
                                                TOTAL ({patientBilling?.currencyImage ?? ""})
                                            </div></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            patientBilling?.billingItems?.map((cur, index) => {
                                                return <tr>
                                                    <td style={{ textIndent: '10px' }}>{cur?.serviceName ?? "-"}</td>
                                                    <td>{cur?.hsnCode ?? "-"}</td>
                                                    <td>{cur?.quantity ?? ""}</td>
                                                    <td>{cur?.currencyImage ?? ""}{cur?.taxableValue ?? "-"}</td>
                                                    <td>{cur?.gstRate ?? "Exempt"}</td>
                                                    <td align="right"><div style={{ paddingRight: '10px' }}>
                                                        {cur?.amount ?? "-"}
                                                    </div></td>
                                                </tr>
                                            })
                                        }

                                    </tbody>
                                </table>

                                <div className="mt-4">
                                    <strong style={{ fontSize: "16px" }}>GST Details</strong>
                                </div>

                                <table className="table mt-2 a4-print-table">
                                    <thead>
                                        <tr>
                                            <th scope="col" align="left" style={{ textIndent: '10px' }}>HSN Code</th>
                                            <th scope="col" align="left" >Amount ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">CGST(%)</th>
                                            <th scope="col" align="left">CGST Amt ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">SGST(%)</th>
                                            <th scope="col" align="left">SGST Amt ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">IGST(%)</th>
                                            <th scope="col" align="left">IGST Amt ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="right" className='text-end'><div style={{ paddingRight: '10px' }}>Total Amount ({patientBilling?.currencyImage ?? ""})</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            patientBilling?.billingItems?.map((cur, index) => {
                                                return <tr>
                                                    <td style={{ textIndent: '10px' }}>{cur?.hsnCode ?? "-"}</td>
                                                    <td>{cur?.taxableValue ?? "-"}</td>
                                                    <td>{cur?.cgstRate ?? "-"}</td>
                                                    <td>{cur?.cgstAmount ?? "-"}</td>
                                                    <td>{cur?.sgstRate ?? "-"}</td>
                                                    <td>{cur?.sgstAmount ?? "-"}</td>
                                                    <td>{cur?.igstRate ?? "-"}</td>
                                                    <td>{cur?.igstAmount ?? "-"}</td>
                                                    <td align="right"><div style={{ paddingRight: '10px' }}>{cur?.amount ?? "-"}</div></td>
                                                </tr>
                                            })
                                        }

                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style={{ textIndent: '10px' }}><strong>Sub Total</strong></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <strong>
                                                    {patientBilling?.billingItems
                                                        ?.reduce((sum, cur) => sum + (parseFloat(cur?.cgstAmount) || 0), 0)
                                                        .toFixed(2) || "-"}
                                                </strong>
                                            </td>
                                            <td></td>
                                            <td>
                                                <strong>
                                                    {patientBilling?.billingItems
                                                        ?.reduce((sum, cur) => sum + (parseFloat(cur?.sgstAmount) || 0), 0)
                                                        .toFixed(2) || "-"}
                                                </strong>
                                            </td>
                                            <td></td>
                                            <td>
                                                <strong>
                                                    {patientBilling?.billingItems
                                                        ?.reduce((sum, cur) => sum + (parseFloat(cur?.igstAmount) || 0), 0)
                                                        .toFixed(2) || "-"}
                                                </strong>
                                            </td>
                                            <td align="right">
                                                <div style={{ paddingRight: '10px' }}>
                                                    <strong>
                                                        {patientBilling?.billingItems
                                                            ?.reduce((sum, cur) => sum + (parseFloat(cur?.amount) || 0), 0)
                                                            .toFixed(2) || "-"}
                                                    </strong>
                                                </div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            {/* <div className="page-break-before"> */}
                            <div style={{ minHeight: "200px" }}>
                                <table className="table mt-4  a4-print-table payment-status-table" style={{ width: "100%", tableLayout: "fixed" }}>
                                    <thead>
                                        <tr>
                                            <td style={{ padding: "8px", width: "50%", border: "1px solid #38C4B9", wordWrap: "break-word", overflowWrap: "break-word", textIndent: "10px" }}>
                                                Payment Status
                                            </td>
                                            <td style={{ borderLeft: "1px solid #38C4B9", padding: "0 10px", width: "50%", border: "1px solid #38C4B9", wordWrap: "break-word", overflowWrap: "break-word", textIndent: "10px" }}>
                                                {paymentType === "Cash" && (
                                                    <>
                                                        Paid By CASH <strong>
                                                            {patientBilling?.billingItems
                                                                ?.reduce((sum, cur) => sum + (parseFloat(cur?.amount) || 0), 0)
                                                                .toFixed(2) || "-"}
                                                        </strong>({patientBilling?.currencyImage ?? ""})
                                                    </>
                                                )}
                                                {paymentType === "Card" && <>Paid By Card {cardNumber && cardNumber.replace(/\D/g, "").length >= 16
                                                    ? `( ${cardType} ending ${cardNumber.replace(/\D/g, "").slice(-4)} )`
                                                    : ""} </>}
                                                {paymentType === "Cheque" && <>Paid By Cheque {chequeNumber ? `(No. ${chequeNumber})` : ""} </>}
                                                {paymentType === "Online Payment" && <>Online Payment {transactionId ? `(Transation ID ${transactionId})` : ""} </>}
                                                {paymentType === "Insurance" && <>Paid by Insurance</>}

                                                {/* Paid By CASH <strong>
                                                    {patientBilling?.billingItems
                                                    ?.reduce((sum, cur) => sum + (parseFloat(cur?.amount) || 0), 0)
                                                    .toFixed(2) || "-"}
                                                </strong> ({patientBilling?.currencyImage ?? ""}) <br />
                                                Paid By Card (VISA ending 1234) <br />
                                                Paid By Cheque (No. 00124) <br />
                                                Online Payment (Transaction ID: [XXXXXXXXX]) <br />
                                                Paid by Insurance */}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr>
                                            <td style={{ verticalAlign: "top", padding: "10px 10px", width: "50%", border: "1px solid #38C4B9", textIndent: "10px" }}>
                                                Payment Date
                                            </td>
                                            <td style={{ borderLeft: "1px solid #38C4B9", padding: "0 10px", width: "50%", border: "1px solid #38C4B9", textIndent: "10px" }}>
                                                {moment(patientBilling?.createdOn).format("DD/MM/YYYY")}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>

                                {/* <div className="mt-3 note">
                                        <strong>NOTES</strong>
                                        <p >The payment was made in cash and has been recorded successfully.</p>
                                    </div> */}
                                <div className="mt-4 note" style={{ pageBreakInside: "avoid" }}>
                                    <strong>Notes:</strong>
                                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                                        {notesItems.map((item, index) => (
                                            <li key={index}>&bull;  {item}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="mx-0 note" style={{ pageBreakInside: "avoid" }}>
                                    <strong>Terms:</strong> All services are subject to GST as per Indian tax regulations. HSN/SAC codes are provided for transparency.
                                </div>

                                {/* <div className="d-flex flex-column align-items-end mt-3 tax ">
                                        <div>
                                            <div>
                                                <p className='mb-1'><strong>Sub Total </strong> :{patientBilling?.currencyImage ?? ""} {patientBilling?.amountDue?.toFixed(2)}</p>
                                                <p className='mb-1'><strong>TAX </strong> : {patientBilling?.currencyImage ?? ""}{patientBilling?.gstTotalAmount ?? "-"}</p>
                                            </div>
                                            <div className="total_amount d-flex" >
                                                <div>TOTAL : </div>
                                                <div>{patientBilling?.currencyImage ?? ""}{patientBilling?.totalAmount ?? "-"}</div>
                                            </div>

                                        </div>
                                    </div> */}
                                <div className="mt-5 mx-4 footer-row" style={{ pageBreakInside: "avoid" }}>
                                    <div className="row align-items-center">
                                        <div className="col-12 col-sm-4 col-md-4 mb-3 mb-sm-0 text-center text-sm-start">
                                            <div
                                                style={{ width: "10%", height: "10%" }}
                                                dangerouslySetInnerHTML={{ __html: patientBilling?.qrCode }}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-8 col-md-8 text-center text-sm-start">
                                            <p className="mb-1 text-sm text-dark">
                                                Generated for {patientBilling?.clinicName} Billing by Winkdoc Billing System
                                            </p>
                                            <p className="mb-0 text-sm">
                                                Learn more about our billing system at:{" "}
                                                <a
                                                    href="https://winkdoc.com"
                                                    className="text-primary text-decoration-none"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Winkdoc Home
                                                </a>
                                            </p>
                                            <p>
                                                For queries, contact{" "}
                                                <a
                                                    href="mailto:billing@apollohospitals.com"
                                                    className="text-primary text-decoration-none"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {`${patientBilling.providerEmail}`}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    {/* <footer className="mt-4 py-4" >
                        <div><strong>Concordia Hill Hospital</strong></div>
                        <div><a href="http://www.concordiahill.com">www.concordiahill.com</a></div>
                        <div>For more information or any issues or concerns, email us at <strong>invoices@concordiahill.com</strong></div>
                    </footer> */}
                </div>
            </div>

            {/* </div > */}
        </>

    );
};

export default PatientBill;
